import React, { Component } from "react";
import { Link } from "react-router";

import Phone01 from "../assets/phone_1.png";
import Phone02 from "../assets/phone_2.png";
import Phone03 from "../assets/phone_3.png";

export default class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="aboss__intro-hero">
        <div className="aboss__intro-hero-container">
          <h1>Organisation for artists made easy.</h1>
          <h2>
            The best suite of tools for artists, managers and booking agents.
          </h2>
          <div className="aboss__intro-hero-container-stats">
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/introduction/components/hero.js